<!-- <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon matSuffix svgIcon="close" color="warn">close</mat-icon>
</button> -->
<!-- <h1 mat-dialog-title></h1> -->
<div class="dialog-content">
    <div class="grid-item-image">
        <img *ngIf="currentImage" [src]="currentImage.url" [alt]="currentImage.altText" [title]="currentImage.title"
            class="grid-item-image--image" onError="this.src='assets/images/img-not-available.png';">
    </div>
    <div class="grid-item-content">
        <h1 class="product-name">{{ currentSku?.name }}</h1>
        <bar-rating [rate]="product?.ratingInfo?.rating" [theme]="'default'"
            (rateChange)="updateRating($event)"></bar-rating>
        <div class="product-options--form--price" *ngIf="company && !company?.allCompanySettings?.shopPriceWithTax">
            <div class="sale-percentage" *ngIf="currentSku?.salePricePercentage">
                - {{ currentSku?.salePricePercentage }} %
            </div>
            <div class="product-price">
                <span
                    [ngClass]="{ 'price-old ': currentSku?.salePricePercentage && currentSku?.salePricePercentage > 0, 'price-new': !(currentSku?.salePricePercentage && currentSku?.salePricePercentage > 0)}"
                    class="float-left">
                    {{ currentSku?.priceWithoutTax?.amount | number: "1.2-2"}}
                    {{currentSku?.priceWithoutTax?.currency | lowercase}}</span>
                <span *ngIf="currentSku?.salePricePercentage && currentSku?.salePricePercentage > 0"
                    class="float-left price-new margin-left-10">
                    {{ currentSku?.salePriceWithoutTax?.amount | number: "1.2-2" }}
                    {{currentSku?.priceWithoutTax?.currency | lowercase}}</span>
            </div>
        </div>
        <div class="product-tax" *ngIf="company && !company?.allCompanySettings?.shopPriceWithTax">+
            {{ product?.taxRate?.rate }}% <span i18n="@@Pdv">PDV</span></div>
        <!-- Price with tax included-->
        <div class="product-options--form--price" *ngIf="company && company?.allCompanySettings?.shopPriceWithTax">
            <div>
                <div class="sale-percentage" *ngIf="currentSku?.salePricePercentage">
                    {{ currentSku?.salePricePercentage }} %
                </div>
                <div class="product-price">
                    <span
                        [ngClass]="{ 'price-old ': currentSku?.salePricePercentage && currentSku?.salePricePercentage > 0, 'price-new': !(currentSku?.salePricePercentage && currentSku?.salePricePercentage > 0)}"
                        class="float-left">
                        {{ (currentSku?.priceWithoutTax?.amount * ((product?.taxRate?.rate / 100) + 1)) | number:
                        "1.2-2"}}
                        {{currentSku?.priceWithoutTax?.currency | lowercase}}</span>
                    <span *ngIf="currentSku?.salePricePercentage && currentSku?.salePricePercentage > 0"
                        class="float-left price-new margin-left-10">
                        {{ (currentSku?.salePriceWithoutTax?.amount * ((product?.taxRate?.rate / 100) + 1)) | number:
                        "1.2-2" }}
                        {{currentSku?.priceWithoutTax?.currency | lowercase}}</span>
                </div>
            </div>
        </div>

        <!-- <div class="sale-percentage" *ngIf="currentSku?.salePricePercentage">
            {{currentSku?.salePricePercentage}} %
        </div> -->
        <!-- <div class="product-price">
            <span
                [ngClass]="{ 'price-old ': currentSku?.salePriceWithoutTax?.amount, 'price-new': !currentSku?.salePriceWithoutTax?.amount}"
                class="float-left">{{currentSku?.priceWithoutTax?.amount | number : '1.2-2' }}
                {{ currentSku?.priceWithoutTax?.currency | lowercase}} </span>
            <span *ngIf="currentSku?.salePriceWithoutTax?.amount"
                class="float-left price-new margin-left-10">{{currentSku?.salePriceWithoutTax?.amount | number : '1.2-2' }}
                {{ currentSku?.salePriceWithoutTax?.currency | lowercase}}
            </span>
        </div>
        <div class="product-tax" i18n="@@VAT">
            + {{product?.taxRate?.rate}}% VAT
        </div> -->
        <p class="dimension">
            <b i18n="@@Code">Code: </b>
            <span class="info">{{ currentSku?.skuId }}</span>
        </p>
        <p class="dimension">
            <b i18n="@@Availability">Availability: </b>
            <span
                [ngClass]="{'pdp-danger-font': productQuantity?.quantityLow, 'pdp-green-font': !productQuantity?.quantityLow}">
                {{productQuantity?.availabilityMessage}}
            </span>
        </p>
        <div *ngIf="product?.features && product?.features?.length > 0">
            <h2 i18n="@@Features"> Features</h2>
            <div class="features">
                <ul>
                    <li *ngFor="let feature of product?.features">
                        {{ feature?.content }}
                    </li>
                </ul>
            </div>
        </div>
        <form name="quickViewForm" [formGroup]="formGroup" novalidate class="form-sm">
            <div class="quantity">
                <div>
                    <h2 i18n="@@Quantity">Quantity</h2>
                    <mat-form-field style="max-width: 145px;">
                        <input type="text" name="quantity" matInput formControlName="quantity"
                            style="text-align: center;">
                    </mat-form-field>
                </div>
            </div>
            <div class="action-buttons">
                <button [disabled]="loading" [routerLink]="[routerLinkUrl]" [queryParams]="{itm: product?.id}"
                    mat-stroked-button color="primary" class="shop-mat-stroked">
                    <span i18n="@@SeeDetails">See Details</span>
                </button>
                <button [disabled]="loading" (click)="addToCart()" mat-flat-button color="primary"
                    class="shop-mat-primary">
                    <span i18n="@@AddToCart">ADD TO CART</span>
                </button>
            </div>
        </form>
    </div>
</div>